import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Quotes from "@/pages/Quotes";
import QuoteForm from "@/pages/QuoteForm";
import QuoteDetail from "@/pages/QuoteDetail";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Interventions from "@/pages/Interventions";
import InterventionForm from "@/pages/InterventionForm";
import InterventionDetail from "@/pages/InterventionDetail";
import Archives from "@/pages/Archives";
import Employees from "@/pages/Employees";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Leaves from "@/pages/Leaves";
import Services from "@/pages/Services";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Landing from "@/pages/Landing";
import Requests from "@/pages/Requests";
import TrainingSignup from "@/pages/TrainingSignup";
import Trainings from "@/pages/Trainings";
import Agent from "@/pages/Agent";

const Guard = ({ roles, children }) => {
  const { user } = useAuth();
  if (roles && user.role !== "admin" && !roles.includes(user.role)) return <Navigate to="/tableau-de-bord" replace />;
  return children;
};

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
};

const C = ["commercial"];
const T = ["technicien"];
const R = ["rh"];
const A = [];

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/formation/inscription" element={<TrainingSignup />} />
      <Route path="/login" element={user ? <Navigate to="/tableau-de-bord" replace /> : <Login />} />
      <Route element={<Protected />}>
        <Route path="/tableau-de-bord" element={<Dashboard />} />
        <Route path="/demandes" element={<Guard roles={C}><Requests /></Guard>} />
        <Route path="/agent-ia" element={<Guard roles={C}><Agent /></Guard>} />
        <Route path="/inscriptions" element={<Guard roles={C}><Trainings /></Guard>} />
        <Route path="/devis" element={<Guard roles={C}><Quotes /></Guard>} />
        <Route path="/devis/nouveau" element={<Guard roles={C}><QuoteForm /></Guard>} />
        <Route path="/devis/:id/modifier" element={<Guard roles={C}><QuoteForm /></Guard>} />
        <Route path="/devis/:id" element={<Guard roles={C}><QuoteDetail /></Guard>} />
        <Route path="/commandes" element={<Guard roles={C}><Orders /></Guard>} />
        <Route path="/factures" element={<Guard roles={C}><Invoices /></Guard>} />
        <Route path="/interventions" element={<Guard roles={T}><Interventions /></Guard>} />
        <Route path="/interventions/nouvelle" element={<Guard roles={T}><InterventionForm /></Guard>} />
        <Route path="/interventions/:id/modifier" element={<Guard roles={T}><InterventionForm /></Guard>} />
        <Route path="/interventions/:id" element={<Guard roles={T}><InterventionDetail /></Guard>} />
        <Route path="/archives" element={<Guard roles={A}><Archives /></Guard>} />
        <Route path="/employes" element={<Guard roles={R}><Employees /></Guard>} />
        <Route path="/employes/:id" element={<Guard roles={R}><EmployeeDetail /></Guard>} />
        <Route path="/conges" element={<Guard roles={R}><Leaves /></Guard>} />
        <Route path="/services" element={<Services />} />
        <Route path="/utilisateurs" element={<Guard roles={A}><Users /></Guard>} />
        <Route path="/parametres" element={<Guard roles={A}><Settings /></Guard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}
